import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const ReporteConciliationPage: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle
        breadcrumbs={widgetsBreadCrumbs}
      >{`${'Reporte conciliación'}`}</PageTitle>
      <View />
    </>
  );
};

export { ReporteConciliationPage };
